module.exports = __webpack_public_path__ + "static/media/processCardGreyStar.6aa525e7.svg";